<ng-container *ngIf="(files$ | async) as files">
  <div class="container mt-4" style="padding-bottom:50px" *ngIf="files.length > 0">
    <div class="it-list-wrapper">
      <ul class="it-list mt-3">

        <!--  Elementi standard template   -->
        <ng-container *ngIf="!props?.elementsToShow; else paginatedTemplate">

          <ng-container *ngIf="props?.endpointCategories">
            <ng-container *ngIf="categoryNames.length > 0">
              <div class="container mt-10" style="padding-bottom:50px">
                <div class="it-list-wrapper">
                  <h6 class="link-list-heading">{{ props?.label || 'Allegati' }}</h6>

                  <ngb-accordion #acc="ngbAccordion">
                    <ng-container *ngFor="let category of categoryNames; let i = index">
                      <ngb-panel [id]="'panel-' + i" [title]="category">
                        <ng-template ngbPanelContent>
                          <ul class="it-list mt-3">
                            <ng-container *ngFor="let file of groupedFilesByCategory[category].files">
                              <ng-container
                                *ngTemplateOutlet="fileItemTemplate; context: { $implicit: file, props: props }"></ng-container>
                            </ng-container>
                          </ul>
                        </ng-template>
                      </ngb-panel>
                    </ng-container>
                  </ngb-accordion>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!props?.endpointCategories">
            <h6 class="link-list-heading">{{props?.label ? props?.label : 'Allegati'}}</h6>
            <ng-container *ngFor="let file of files">
              <ng-container *ngTemplateOutlet="fileItemTemplate; context: { $implicit: file }"></ng-container>
            </ng-container>
          </ng-container>

        </ng-container>
        <!-- end of standard template -->

        <!-- Paginated template  -->
        <ng-template #paginatedTemplate>

          <ng-container *ngIf="props?.endpointCategories">
            <ng-container *ngIf="categoryNames.length > 0">
              <div class="container mt-4" style="padding-bottom:50px">
                <div class="it-list-wrapper">
                  <h6 class="link-list-heading">{{ props?.label || 'Allegati' }}</h6>

                  <ngb-accordion #acc="ngbAccordion">
                    <ng-container *ngFor="let category of categoryNames; let i = index">
                      <ngb-panel [id]="'panel-' + i" [title]="category">
                        <ng-template ngbPanelContent>
                          <ul class="it-list mt-3">
                            <ng-container *ngFor="let file of getPaginatedFilesByCategory(category)">
                              <ng-container
                                *ngTemplateOutlet="fileItemTemplate; context: { $implicit: file, props: props }"></ng-container>
                            </ng-container>
                          </ul>
                        </ng-template>
                      </ngb-panel>
                    </ng-container>
                  </ngb-accordion>

                  <!-- Pagination for categorized view -->
                  <ngb-pagination class="d-flex justify-content-start" [collectionSize]="files.length" [(page)]="page"
                    [pageSize]="pageSize" size="sm" (pageChange)="onPageChange($event)"></ngb-pagination>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="!props?.endpointCategories">
            <h6 class="link-list-heading">{{props?.label ? props?.label : 'Allegati'}}</h6>
            <ng-container *ngFor="let file of paginatedFiles">
              <ng-container *ngTemplateOutlet="fileItemTemplate; context: { $implicit: file, props }"></ng-container>
            </ng-container>
            <!-- paginazione -->
            <ngb-pagination class="d-flex justify-content-start" [collectionSize]="files.length" [(page)]="page"
              [pageSize]="pageSize" size="sm" (pageChange)="onPageChange($event)"></ngb-pagination>
          </ng-container>

        </ng-template>
        <!-- end of Paginated template -->
      </ul>
    </div>
  </div>
</ng-container>

<!--file item template-->
<ng-template #fileItemTemplate let-file let-props>
  <li>
    <div class="list-item border-0 mb-3">
      <div class="me-2" [ngSwitch]="file?.extension">
        <img src="assets/svg/file-pdf.svg" alt="file pdf" *ngSwitchCase="'pdf'">
        <img src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xls'">
        <img src="assets/svg/file-excel.svg" alt="file sheet" *ngSwitchCase="'xlsx'">
        <img src="assets/svg/file-zip.svg" alt="file zip" *ngSwitchCase="'zip'">
        <img src="assets/svg/file-zip.svg" alt="file rar" *ngSwitchCase="'rar'">
        <img src="assets/svg/file-doc.svg" alt="doc" *ngSwitchDefault>
      </div>

      <div class="it-right-zone p-0 ms-1" *ngIf="props?.showAction else fileLinkTemplate">
        {{ getFileTitle(file) }}
      </div>
      <ng-template #fileLinkTemplate>
        <div class="it-right-zone p-0 ms-1">
          <a href="javascript:void(0)" (click)="downloadFile(file)" class="link-primary text-decoration-underline">
            {{ getFileTitle(file) }}
          </a>
        </div>
      </ng-template>

      <span class="it-multiple" *ngIf="props?.showAction">
        <div ngbDropdown class="d-inline-block">
          <button type="button" class="btn btn-primary btn-xs" [id]="file.id+'_action'" ngbDropdownToggle>
            Azioni
          </button>
          <div ngbDropdownMenu [attr.aria-labelledby]="file.id+'_action'">
            <button (click)="showPreview(file)" ngbDropdownItem>Anteprima</button>
            <button (click)="downloadFile(file)" ngbDropdownItem>Download</button>
          </div>
        </div>
      </span>
    </div>
  </li>
</ng-template>
<!-- end of file item template -->